// ================================================================
// src/components/books/StepQuizSyncListener.jsx
// ================================================================
// گوش دادن به رویدادهای BooksEngine و همگام‌سازی quiz های مرحله
// - version:draft-created-from-published → clone quizzes
// - project:hard-deleted → remove quizzes
// ================================================================

import { useEffect, useRef } from 'react';
import { engine } from '../../core/books/storage.js';
import dataEngine from '../../core/books/data.js';
import { useExams } from '../Exams/ExamContext.jsx';

export default function StepQuizSyncListener() {
  const { exams, upsertStepQuiz, removeStepQuizzesForProject } = useExams();
  const examsRef = useRef(exams);

  useEffect(() => {
    examsRef.current = exams;
  }, [exams]);

  // 🆕 Clone quiz ها وقتی draft جدید از published ساخته می‌شه
  useEffect(() => {
    const unsub = engine.on('version:draft-created-from-published', (payload) => {
      const { draftVersionId, sourceVersionId } = payload || {};
      if (!sourceVersionId || !draftVersionId) return;

      const sourceQuizzes = examsRef.current.filter((e) =>
        e.isStepQuiz && e.linkContext?.versionId === sourceVersionId
      );

      if (sourceQuizzes.length === 0) return;

      console.log(`🔄 Cloning ${sourceQuizzes.length} step-quiz to draft ${draftVersionId}`);

      const quizIdMap = {}; // old → new

      for (const oldQuiz of sourceQuizzes) {
        try {
          const newQuiz = upsertStepQuiz({
            ...oldQuiz,
            id: null, // ID جدید
            results: [],
            createdAt: new Date().toISOString(),
            linkContext: {
              ...oldQuiz.linkContext,
              versionId: draftVersionId,
            },
          });
          if (newQuiz?.id) quizIdMap[oldQuiz.id] = newQuiz.id;
        } catch (e) {
          console.warn('[StepQuizSync] clone failed:', e);
        }
      }

      // آپدیت step.quizId در draft version
      try {
        const draft = dataEngine.version.get(draftVersionId);
        if (!draft) return;

        let changed = false;
        const newChapters = draft.chapters.map((ch) => ({
          ...ch,
          lessons: (ch.lessons || []).map((ls) => ({
            ...ls,
            steps: (ls.steps || []).map((st) => {
              if (st.type === 'quiz' && st.quizId && quizIdMap[st.quizId]) {
                changed = true;
                return { ...st, quizId: quizIdMap[st.quizId] };
              }
              return st;
            }),
          })),
        }));

        if (changed) {
          dataEngine.version.updateChapters(draftVersionId, newChapters);
          console.log(`✅ Updated draft step quizIds`);
        }
      } catch (e) {
        console.warn('[StepQuizSync] updateChapters failed:', e);
      }
    });

    return unsub;
  }, [upsertStepQuiz]);

  // 🆕 حذف quiz ها وقتی پروژه hard-delete می‌شه
  useEffect(() => {
    const unsub = engine.on('project:hard-deleted', (payload) => {
      const { projectId } = payload || {};
      if (!projectId) return;
      try {
        removeStepQuizzesForProject(projectId);
      } catch (e) {
        console.warn('[StepQuizSync] cleanup failed:', e);
      }
    });
    return unsub;
  }, [removeStepQuizzesForProject]);

  return null;
}